import { CustomValidators } from 'shared/validation/custom-validators';

/* eslint-disable */
export const userData: any = [
  {
    // "item_name": "ZZZ-EMAIL",
    "field_map": "email",
    "item_name": "email",
    "title": "Email address",
    "hint_detail": "Email address",
    "hint_panel" : "Email address",
    "example": "",
    "sequence": 3,
    "show_more": true,
    "lookup": null,
    "validation": {
      'PROFILE_VALIDATION': {
        maxLength: 254,
        validator: CustomValidators.email,
        message: 'A valid email must be provided and may not be longer than 254 characters',
        required: true,
      },
    },
  },
  {
    "field_map": "isAdministrator",
    "item_name": "is_administrator",
    "title": "Is administrator",
    "hint_detail": "",
    "hint_panel" : "",
    "example": "",
    "sequence": 6,
    "show_more": true,
    "lookup": null
  },
  {
    "field_map": "productCatalogView",
    "item_name": "product_catalog_view",
    "title": "Product Catalog View",
    "hint_detail": "",
    "hint_panel" : "",
    "example": "",
    "sequence": 7,
    "show_more": true,
    "lookup": null
  },
  {
    "field_map": "damView",
    "item_name": "dam_view",
    "title": "DAM View",
    "hint_detail": "",
    "hint_panel" : "",
    "example": "",
    "sequence": 8,
    "show_more": true,
    "lookup": null
  },
  {
    "field_map": "fitmentsView",
    "item_name": "fitments_view",
    "title": "Fitments View",
    "hint_detail": "",
    "hint_panel" : "",
    "example": "",
    "sequence": 8,
    "show_more": true,
    "lookup": null
  },
  {
    "field_map": "productCatalogEdit",
    "item_name": "product_catalog_edit",
    "title": "Product Catalog Edit",
    "hint_detail": "",
    "hint_panel" : "",
    "example": "",
    "sequence": 7,
    "show_more": true,
    "lookup": null
  },
  {
    "field_map": "damEdit",
    "item_name": "dam_edit",
    "title": "DAM Edit",
    "hint_detail": "",
    "hint_panel" : "",
    "example": "",
    "sequence": 8,
    "show_more": true,
    "lookup": null
  },
  {
    "field_map": "fitmentsEdit",
    "item_name": "fitments_edit",
    "title": "Fitments Edit",
    "hint_detail": "",
    "hint_panel" : "",
    "example": "",
    "sequence": 8,
    "show_more": true,
    "lookup": null
  },
  {
    "field_map": "repository",
    "item_name": "repository",
    "title": "Repository",
    "hint_detail": "",
    "hint_panel" : "",
    "example": "",
    "sequence": 9,
    "show_more": true,
    "lookup": null
  },
]
/* eslint-enable */
